// Every page title starts at the same distance from main content's left edge:
// 32px as in Figma, 52px while the sidebar is closed so the title clears the
// hamburger. SidebarView writes the value on <main>; its page headers read it.
// Pages outside SidebarView (the Create Groups standard pages) have no sidebar
// to close and keep a plain 32px.
const INSET_PROPERTY = "--page-title-inset";
const SIDEBAR_OPEN_INSET = "32px";
const SIDEBAR_CLOSED_INSET = "52px";

export const pageTitleInsetStyle = (isSidebarOpen) => ({
  [INSET_PROPERTY]: isSidebarOpen ? SIDEBAR_OPEN_INSET : SIDEBAR_CLOSED_INSET,
});

// A page rendered outside SidebarView gets the open-sidebar inset.
export const pageTitleInset = `var(${INSET_PROPERTY}, ${SIDEBAR_OPEN_INSET})`;
